import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../App.css";

export default function ThankYou() {
  const imgCDNURL = process.env.REACT_APP_POSTNU_CDN_URL;

    const getSunWestSuccessYears = () => {

    //Sun West founded in 08/12/1980
    const foundedDate = new Date('1980-08-12');
    const todayDate = new Date();    
    const yearDiff = todayDate.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday = (
    todayDate.getMonth() < foundedDate.getMonth() ||
    (todayDate.getMonth() === foundedDate.getMonth() && todayDate.getDate() < foundedDate.getDate())
    );
    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
    }
  return (
    <div className="thankyoubg1 mt-5 mb-5">
      <Container>
        <img
          src={imgCDNURL + "eventmemoryrightdot.webp"}
          className="eventmemoryrightdot"
          alt="eventmemoryrightdot"
        ></img>
        <img
          src={imgCDNURL + "thankyouyellowcircle.webp"}
          className="thankyouyellowcircle"
          alt="thankyouyellowcircle"
        ></img>
        <Row className="thankyoucontent">
          <Col lg={12} md={12}>
            <h3 className="thankyoutitle mt-4 mb-4">
              Thank You for Attending the NU YOU RECON Event!
            </h3>

            <p className="thankyoutext">
              A Big Thanks to everyone who attended the NU YOU RECON Event. We
              hope that you enjoyed the experience. Sun West Mortgage has been
              helping families achieve their dream of homeownership since 1980.
              We are so grateful for the {getSunWestSuccessYears()} years of support from our employees,
              partners, and homebuyers who have made us a household name in the
              mortgage industry.
            </p>

            <p className="thankyoutext">
              So much has changed in the mortgage industry since 1980, but one
              thing that will never change is Sun West’s commitment to Fair
              Lending and our ambition to never settle. We refuse to accept
              mediocre technology, less than great rates, unnecessary fees, and
              clunky processes. For {getSunWestSuccessYears()} years, we have dedicated ourselves
              to revolutionize the mortgage industry and we’ll never stop trying
              to make it even better.
            </p>

            <p className="thankyoutext">
              We look forward to seeing you again at our future events.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
